import { gql } from '@apollo/client';
import { Box, Grid, Typography } from '@mui/material';
import { InfiniteScrollBoundary } from 'components/common/InfiniteScrollBoundary';
import { SocialPostCardView } from 'features/socialPost';
import {
  CreatorProfilesCommunityFilters,
  useGetCommunitySocialPostsForSlCommunityPostsQuery,
} from 'graphql/generated';
import { theme } from 'styles/theme';

// eslint-disable-next-line
gql`
  query GetCommunitySocialPostsForSLCommunityPosts(
    $input: GetCreatorProfileCommunitySocialPostsArgs!
  ) {
    getCreatorProfileCommunitySocialPosts(input: $input) {
      data {
        id
        ...SocialPostFragmentSocialPostCardView
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

interface SocialListeningCommunityPostsProps
  extends CreatorProfilesCommunityFilters {
  onClickPost: (postId: string) => void;
}

export const SocialListeningCommunityPosts = (
  props: SocialListeningCommunityPostsProps,
) => {
  const { onClickPost, ...filters } = props;
  const {
    data: socialPostsData,
    loading: socialPostsLoading,
    fetchMore: fetchMoreSocialPosts,
  } = useGetCommunitySocialPostsForSlCommunityPostsQuery({
    variables: {
      input: {
        filters,
      },
    },
    fetchPolicy: 'cache-and-network',
  });

  const socialPosts =
    socialPostsData?.getCreatorProfileCommunitySocialPosts.data ?? [];

  return socialPosts.length ? (
    <>
      <Grid container spacing={6}>
        {socialPosts.map((socialPost) => {
          return (
            <Grid item xs={12} sm={6} md={3} lg={2.4} key={socialPost.id}>
              <Box
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onClickPost(socialPost.id);
                }}
              >
                <SocialPostCardView socialPost={socialPost} />
              </Box>
            </Grid>
          );
        })}
      </Grid>
      <InfiniteScrollBoundary
        disabled={
          socialPostsLoading ||
          !socialPostsData?.getCreatorProfileCommunitySocialPosts.pageInfo
            .hasNextPage
        }
        onVisible={() => {
          fetchMoreSocialPosts({
            variables: {
              input: {
                filters,
                skip: socialPostsData?.getCreatorProfileCommunitySocialPosts
                  .data.length,
              },
            },
            updateQuery: (prev, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prev;
              return {
                getCreatorProfileCommunitySocialPosts: {
                  ...fetchMoreResult.getCreatorProfileCommunitySocialPosts,
                  data: [
                    ...prev.getCreatorProfileCommunitySocialPosts.data,
                    ...fetchMoreResult.getCreatorProfileCommunitySocialPosts
                      .data,
                  ],
                },
              };
            },
          });
        }}
      />
    </>
  ) : (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Typography variant="headline-sm" color={theme.colors?.utility[600]}>
        {socialPostsLoading ? 'Loading...' : 'No posts found'}
      </Typography>
    </Box>
  );
};
